import { c as _c } from "react/compiler-runtime";
import { startTransition, useCallback, useEffect, useRef, useState } from "react";
export function useTruncation() {
  const $ = _c(5);
  const valueRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const element = valueRef.current;
      if (!element) {
        return;
      }
      startTransition(() => {
        setIsTruncated(element.scrollWidth > element.clientWidth);
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const recalcTruncation = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const element_0 = valueRef.current;
      if (!element_0) {
        return;
      }
      let raf = 0;
      const scheduleRecalc = () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(recalcTruncation);
      };
      scheduleRecalc();
      let resizeObserver = null;
      if (typeof ResizeObserver !== "undefined") {
        resizeObserver = new ResizeObserver(scheduleRecalc);
        resizeObserver.observe(element_0);
      }
      let mutationObserver = null;
      if (typeof MutationObserver !== "undefined") {
        mutationObserver = new MutationObserver(scheduleRecalc);
        mutationObserver.observe(element_0, {
          subtree: true,
          characterData: true,
          childList: true
        });
      }
      window.addEventListener("resize", scheduleRecalc);
      return () => {
        cancelAnimationFrame(raf);
        window.removeEventListener("resize", scheduleRecalc);
        if (resizeObserver) {
          resizeObserver.disconnect();
        }
        if (mutationObserver) {
          mutationObserver.disconnect();
        }
      };
    };
    t2 = [recalcTruncation];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== isTruncated) {
    t3 = {
      valueRef,
      isTruncated
    };
    $[3] = isTruncated;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}